<template>
      <div class="profile d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="listing-navbar bg-primary d-flex align-items-center gap-3 shadow-sm mb-auto p-3">
            <router-link :to="'/'"><i class="bi bi-arrow-left text-white fs-5"></i></router-link>
            <a href="#" class="text-white" data-bs-toggle="modal" data-bs-target="#categories">
               <div class="d-flex align-items-center gap-2">
                  <img src="img/delivery-boy.jpg" alt="" class="rounded-pill img-fluid">
                  <div>
                     <h6 class="fw-bold text-white mb-0">
                        <i class="bi bi-person-circle me-1"></i>{{ profile.name }}
                      </h6>
                      
                  </div>
               </div>
            </a>
            <div class="d-flex align-items-center gap-2 ms-auto">
               <!-- <a class="toggle hc-nav-trigger hc-nav-1" href="#" role="button" aria-controls="hc-nav-1">
               <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
               <i class="bi bi-list d-flex m-0 h4 text-white"></i>
               </b>  
               </a> -->
            </div>
         </div>
         <!-- body -->
         <div class="vh-100 my-auto overflow-auto p-3">
            <div class="mb-4 rounded-3 shadow-sm overflow-hidden">
               <div data-bs-toggle="offcanvas" data-bs-target="#editaccount" aria-controls="editaccount" class="bg-white border-bottom p-3">
                  <div class="d-flex gap-3 align-items-center">
                     <i class="bi bi-pencil fs-5 text-muted"></i>
                     <span>
                        <p class="m-0 small text-muted">My Account</p>
                        <p class="m-0">{{ profile.name }}</p>
                        <p class="m-0">{{ profile.mobile }}</p>
                     </span>
                     <!-- <a href="#" class="text-primary ms-auto d-flex"><i class="bi bi-chevron-right fs-6"></i></a> -->
                  </div>
               </div>
               <!-- <div data-bs-toggle="offcanvas" data-bs-target="#location" aria-controls="location" class="bg-white border-bottom p-3">
                  <div class="d-flex gap-3 align-items-center">
                     <i class="bi bi-geo-alt fs-5 text-muted"></i>
                     <span>
                        <p class="m-0 small text-muted">Addresses</p>
                        <p class="m-0">Share, Edit & Add New Addresses</p>
                     </span>
                     <a href="#" class="text-primary ms-auto d-flex"><i class="bi bi-chevron-right fs-6"></i></a>
                  </div>
               </div>
               <div data-bs-toggle="offcanvas" data-bs-target="#help" aria-controls="help" class="bg-white p-3">
                  <div class="d-flex gap-3 align-items-center">
                     <i class="bi bi-question-circle fs-5 text-muted"></i>
                     <span>
                        <p class="m-0 small text-muted">Help</p>
                        <p class="m-0">FAQs & Links</p>
                     </span>
                     <a href="#" class="text-primary ms-auto d-flex"><i class="bi bi-chevron-right fs-6"></i></a>
                  </div>
               </div> -->
            </div>
            <h5 class="fw-bold text-black mb-3">Listing</h5>
            <h7 class="fw-bold text-black mb-3 ml-3" v-if="food.length">Food</h7>
            <div class="bg-white rounded-3 shadow-sm mb-3" v-for="(data_row,i) in food">
              <div class="d-flex align-items-start justify-content-between border-bottom p-3">
                  <div>
                     <h6 class="fw-bold text-black osahan-mb-1">{{data_row.name}}</h6>
                     <p class="text-muted small mb-2">{{data_row.catname}}</p>
                     <a href="#" class="text-muted"><i class="bi bi-geo-alt"></i>{{data_row.location}}</a>
                  </div>
                    <p v-if="data_row.status === 'Pending'"
                        class="bg-danger bg-opacity-10 text-danger rounded small px-2 py-1">
                     {{ data_row.status }} <i class="icofont-close-circled ms-1"></i>
                     </p>
                     
                     <p v-else-if="data_row.status === 'Accepted'"
                        class="bg-success bg-opacity-10 text-success rounded small px-2 py-1">
                     {{ data_row.status }} <i class="icofont-check-circled ms-1"></i>
                     </p>
                     
                  
                   
               </div>
               <div class="p-3">
                  <p class="mb-1">{{data_row.description}}</p>
                  <p class="text-muted small text-info m-0"><i class="icofont-clock-time"></i> {{data_row.iddate}}</p>
               </div>
               <div class="p-3">
                  <button type="button" class="btn btn-success me-2 text-white">
                    <router-link :to="'/form?name=' + 'food' + '&id=' + data_row.id" class="text-white">
                      Edit
                    </router-link>
                  </button>
                  
                  <button v-if="data_row.userstatus === 'Enable'" type="button" class="btn btn-danger" v-on:click="disableListing(data_row.id,'food')">
                     Disable
                  </button>

                  <button v-else-if="data_row.userstatus === 'Disable'" type="button" class="btn btn-info" v-on:click="disableListing(data_row.id,'food')">
                    Enable
                  </button>

                </div>
                
           
            </div>


            <!-- start event--------------------------------------------------------------------------------->


            <h7 class="fw-bold text-black mb-3 ml-3" v-if="event.length">Event</h7>
            <div class="bg-white rounded-3 shadow-sm mb-3" v-for="(data_row,i) in event">
              
               <div class="d-flex align-items-start justify-content-between border-bottom p-3">
                  <div>
                     <h6 class="fw-bold text-black osahan-mb-1">{{data_row.name}}</h6>
                     <p class="text-muted small mb-2">Time:{{data_row.time}}</p>
                     <a href="#" class="text-muted"><i class="bi bi-geo-alt"></i>{{data_row.location}}</a>
                  </div>
                  <p v-if="data_row.status === 'Pending'"
                  class="bg-danger bg-opacity-10 text-danger rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-close-circled ms-1"></i>
               </p>
               
               <p v-else-if="data_row.status === 'Accepted'"
                  class="bg-success bg-opacity-10 text-success rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-check-circled ms-1"></i>
               </p>
               </div>
               <div class="p-3">
                  <p class="mb-1">{{data_row.description}}</p>
                  <p class="text-muted small text-info m-0"><i class="icofont-clock-time"></i> {{data_row.iddate}}</p>
               </div>
               <div>
                  <button type="button" class="btn btn-success me-2">
                  <router-link :to="'/form?name=' + 'event' + '&id=' + data_row.id" class="text-white">
                     Edit
                  </router-link>
                  </button>
                   
                  <button v-if="data_row.userstatus === 'Enable'" type="button" class="btn btn-danger" v-on:click="disableListing(data_row.id,'event')">
                     Disable
                  </button>

                  <button v-else-if="data_row.userstatus === 'Disable'" type="button" class="btn btn-info" v-on:click="disableListing(data_row.id,'event')">
                    Enable
                  </button>




               </div>
            </div>


            <!-- end event----------------------------------------------------------------------------------- -->

            <!-- start news--------------------------------------------------------------------------------->


            <h7 class="fw-bold text-black mb-3 ml-3" v-if="news.length">News</h7>
            <div class="bg-white rounded-3 shadow-sm mb-3" v-for="(data_row,i) in news">
              
               <div class="d-flex align-items-start justify-content-between border-bottom p-3">
                  <div>
                     <h6 class="fw-bold text-black osahan-mb-1">{{data_row.name}}</h6>
                     <!-- <p class="text-muted small mb-2">{{data_row.time}}</p> -->
                     <a href="#" class="text-muted"><i class="bi bi-geo-alt"></i>{{data_row.location}}</a>
                  </div>
                  <p v-if="data_row.status === 'Pending'"
                  class="bg-danger bg-opacity-10 text-danger rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-close-circled ms-1"></i>
               </p>
               
               <p v-else-if="data_row.status === 'Accepted'"
                  class="bg-success bg-opacity-10 text-success rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-check-circled ms-1"></i>
               </p>
               </div>
               <div class="p-3">
                  <p class="mb-1">{{data_row.description}}</p>
                  <p class="text-muted small text-info m-0"><i class="icofont-clock-time"></i> {{data_row.iddate}}</p>
               </div>
               <div>
                  <button type="button" class="btn btn-success me-2">
                  <router-link :to="'/form?name=' + 'news' + '&id=' + data_row.id" class="text-white">
                     Edit
                  </router-link>
                  </button>
            
                  <button v-if="data_row.userstatus === 'Enable'" type="button" class="btn btn-danger" v-on:click="disableListing(data_row.id,'news')">
                     Disable
                  </button>

                  <button v-else-if="data_row.userstatus === 'Disable'" type="button" class="btn btn-info" v-on:click="disableListing(data_row.id,'news')">
                    Enable
                  </button>
                   
               </div>
            </div>


            <!-- end news----------------------------------------------------------------------------------- -->

            




            <!-- start Business--------------------------------------------------------------------------------->


            <h7 class="fw-bold text-black mb-3 ml-3" v-if="business.length">Business</h7> 
            <div class="bg-white rounded-3 shadow-sm mb-3" v-for="(data_row,i) in business">
               
               <div class="d-flex align-items-start justify-content-between border-bottom p-3">
                  <div>
                     <h6 class="fw-bold text-black osahan-mb-1">{{data_row.name}}</h6>
                     <p class="text-muted small mb-2">{{data_row.offer}}</p>
                     <!-- <a href="#" class="text-muted"><i class="bi bi-geo-alt"></i>{{data_row.mobile}}</a> -->
                  </div>
                  <p v-if="data_row.status === 'Pending'"
                  class="bg-danger bg-opacity-10 text-danger rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-close-circled ms-1"></i>
               </p>
               
               <p v-else-if="data_row.status === 'Accepted'"
                  class="bg-success bg-opacity-10 text-success rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-check-circled ms-1"></i>
               </p>
               </div>
               <div class="p-3">
                  <p class="mb-1">{{data_row.description}}</p>
                  <p class="text-muted small text-info m-0"><i class="icofont-clock-time"></i> {{data_row.iddate}}</p>
               </div>
               <div>
                  <button type="button" class="btn btn-success me-2">
                  <router-link :to="'/form?name=' + 'business' + '&id=' + data_row.id" class="text-white">
                     Edit
                  </router-link>
                  </button>
  
                   <button v-if="data_row.userstatus === 'Enable'" type="button" class="btn btn-danger" v-on:click="disableListing(data_row.id,'business')">
                     Disable
                  </button>

                  <button v-else-if="data_row.userstatus === 'Disable'" type="button" class="btn btn-info" v-on:click="disableListing(data_row.id,'business')">
                    Enable
                  </button>
               </div>
            </div>


            <!-- end Business----------------------------------------------------------------------------------- -->



            <!-- start Business--------------------------------------------------------------------------------->


            <h7 class="fw-bold text-black mb-3 ml-3" v-if="property.length">Property</h7> 
            <div class="bg-white rounded-3 shadow-sm mb-3" v-for="(data_row,i) in property">
              
               <div class="d-flex align-items-start justify-content-between border-bottom p-3">
                  <div>
                     <h6 class="fw-bold text-black osahan-mb-1">{{data_row.name}}</h6>
                     <p class="text-muted small mb-2">{{data_row.offer}}</p>
                     <a href="#" class="text-muted"><i class="bi bi-geo-alt"></i>{{data_row.location}}</a> 
                  </div>
                  <p v-if="data_row.status === 'Pending'"
                  class="bg-danger bg-opacity-10 text-danger rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-close-circled ms-1"></i>
               </p>
               
               <p v-else-if="data_row.status === 'Accepted'"
                  class="bg-success bg-opacity-10 text-success rounded small px-2 py-1">
               {{ data_row.status }} <i class="icofont-check-circled ms-1"></i>
               </p>
               </div>
               <div class="p-3">
                  <p class="mb-1">{{data_row.description}}</p>
                  <p class="text-muted small text-info m-0"><i class="icofont-clock-time"></i> {{data_row.iddate}}</p>
               </div>
               <div>
                  <button type="button" class="btn btn-success me-2">
                  <router-link :to="'/form?name=' + 'properties' + '&id=' + data_row.id" class="text-white">
                        Edit
                  </router-link>
                  </button>
 
                  <button v-if="data_row.userstatus === 'Enable'" type="button" class="btn btn-danger" v-on:click="disableListing(data_row.id,'properties')">
                     Disable
                  </button>

                  <button v-else-if="data_row.userstatus === 'Disable'" type="button" class="btn btn-info" v-on:click="disableListing(data_row.id,'properties')">
                    Enable
                  </button>
                   
               </div>
            </div>


            <!-- end property----------------------------------------------------------------------------------- -->


                  <!-- start job--------------------------------------------------------------------------------->


                  <h7 class="fw-bold text-black mb-3 ml-3" v-if="job.length">Job</h7> 
                  <div class="bg-white rounded-3 shadow-sm mb-3" v-for="(data_row,i) in job">
                   
                     <div class="d-flex align-items-start justify-content-between border-bottom p-3">
                        <div>
                           <h6 class="fw-bold text-black osahan-mb-1">{{data_row.title}}</h6>
                           <p class="text-muted small mb-2">{{data_row.jobtype}}</p>
                           <a href="#" class="text-muted"><i class="bi bi-geo-alt"></i>{{data_row.joblocation}}</a> 
                        </div>
                        <p v-if="data_row.status === 'Pending'"
                        class="bg-danger bg-opacity-10 text-danger rounded small px-2 py-1">
                     {{ data_row.status }} <i class="icofont-close-circled ms-1"></i>
                     </p>
                     
                     <p v-else-if="data_row.status === 'Accepted'"
                        class="bg-success bg-opacity-10 text-success rounded small px-2 py-1">
                     {{ data_row.status }} <i class="icofont-check-circled ms-1"></i>
                     </p>
                     </div>
                     <div class="p-3">
                        <p class="mb-1">{{data_row.description}}</p>
                        <p class="text-muted small text-info m-0"><i class="icofont-clock-time"></i> {{data_row.iddate}}</p>
                     </div>
                     <div>
                        <button type="button" class="btn btn-success me-2">
                        <router-link :to="'/form?name=' + 'job' + '&id=' + data_row.id" class="text-white">
                             Edit
                        </router-link>
                        </button>
           
                         
                       <button v-if="data_row.userstatus === 'Enable'" type="button" class="btn btn-danger" v-on:click="disableListing(data_row.id,'job')">
                        Disable
                     </button>
   
                     <button v-else-if="data_row.userstatus === 'Disable'" type="button" class="btn btn-info" v-on:click="disableListing(data_row.id,'job')">
                       Enable
                     </button>
                      


                     </div>
                  </div>
      
      
                  <!-- end job----------------------------------------------------------------------------------- -->
      
















            <!-- logout -->
            
               <div class="bg-primary d-flex align-items-center rounded-3 shadow-sm justify-content-between p-3" @click="logout">
                  <h6 class="fw-bold text-white text-uppercase m-0">Logout Options</h6>
                  <i class="icofont-rounded-right text-white h6 m-0"></i>
               </div>
      
            <p class="pt-3 text-muted text-center small mb-0">App version 1.0.1</p>
         </div>
      </div>
      <!-- Edit Account offcanvas -->
      <div class="offcanvas offcanvas-end bg-white border-0" tabindex="-1" id="editaccount" aria-labelledby="editaccountLabel">
         <div class="offcanvas-header bg-primary shadow-sm d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left text-white fs-5"></i></a>
            <h6 class="offcanvas-title text-uppercase text-white fw-bold" id="editaccountLabel">Edit Account</h6>
         </div>
         <div class="offcanvas-body">
            <form>
               <div class="mb-4">
                  <label for="exampleFormControlName"
                     class="form-label text-uppercase text-muted small mb-0">Name</label>
                  <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                     id="exampleFormControlName" placeholder="name" v-model="profile.name">
               </div>
               <div class="mb-4">
                  <label for="exampleFormControlNumber" class="form-label text-uppercase text-muted small mb-0">Phone
                  Number</label>
                  <input type="number" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                     id="exampleFormControlNumber" placeholder="number"  v-model="profile.mobile">
               </div>
               <!--<div>-->
               <!--   <label for="exampleFormControlEmail" class="form-label text-uppercase text-muted small mb-0">Email-->
               <!--   Address</label>-->
               <!--   <input type="email" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"-->
               <!--      id="exampleFormControlEmail" placeholder="email" value="">-->
               <!--</div>-->
            </form>
         </div>
         <div class="offcanvas-footer shadow-sm d-flex gap-3">
            <a href="#" class="btn bg-white shadow-sm border btn-light text-primary w-100 text-uppercase btn-lg fw-bold col" data-bs-dismiss="offcanvas" aria-label="Close">Cancel</a>
            <a class="btn btn-primary w-100 text-uppercase btn-lg fw-bold col rounded-3" data-bs-dismiss="offcanvas" aria-label="Close" @click="updateProfile()">Change</a>
         </div>
      </div>
    
   </template>
   
<script> 
   import axios from "@/plugins/axios";  
   
   export default {
     name: 'profile',
     components: { 
     },
     mounted() {

       this.getHomeBasic(); // Call the method here
   },
     data() {
       return {
         loading:false,
         error:null,
         profile:[], 
         food:[],
         event:[], 
         news:[], 
         business:[],
         property:[],
         job:[],
       }
     },
     methods:{
       initializeHomeContent(){

       // this.getHomeBasic();
       },
       async disableListing(id,what) {
         var self=this;
         axios.post("disable_list",{_id:id,_what:what}).then((response) => {
               self.profile = response.data.profile;
               self.food = response.data.food;
               self.event = response.data.event;
               self.news = response.data.news;
               self.business = response.data.business;
               self.property = response.data.property;
               self.job = response.data.job;
         }).then(() => {
                  self.initializeHomeContent();
             }).catch((err) => {
               
             });;
       },

  async updateProfile(){
         var self=this;
         if(!self.profile.name){
             return;
         }
         axios.post("update_profile",{name:self.profile.name}).then((response) => {
               self.profile = response.data.profile; 
         }).then(() => {
                  
             }).catch((err) => {
               
             });;
       },



       async logout() {
         localStorage.setItem('token','');
         this.$router.push('/');
         this.$router.go(-1); 
       },







       async getHomeBasic() {
           this.loading = true;
           this.error = null;
     
           try {
              var self=this;
               axios.post("getprofileview").then((response) => {
               self.profile = response.data.profile;
               self.food = response.data.food;
               self.event = response.data.event;
               self.news = response.data.news;
               self.business = response.data.business;
               self.property = response.data.property;
               self.job = response.data.job;


           
             }).then(() => {
                  self.initializeHomeContent();
             }).catch((err) => {
               
             });;
            
   
           } catch (err) {
             this.error = err.response?.data?.message || "Login failed. Please try again.";
           } finally {
             this.loading = false;
           }
         }, 
     }
   }
   </script>
   